(function () {
  var launcherInteracted = false;
  var guardObserver = null;
  var guardStarted = false;
  var promptSelectors = ['.smile-prompt-frame-container'];
  var launcherSelector = '.smile-launcher-frame-container';

  function isMinionsPage(pathname) {
    return pathname === '/collections/minions-collection';
  }

  function markLauncherInteraction() {
    launcherInteracted = true;
    if (guardObserver) {
      guardObserver.disconnect();
      guardObserver = null;
      window.__minionsSmilePopupGuardObserver = null;
    }
  }

  function shouldSuppressPrompt() {
    return launcherInteracted === false;
  }

  function suppressAutoPrompt(root) {
    var removed = 0;

    if (!root || typeof root.querySelectorAll !== 'function' || !shouldSuppressPrompt()) {
      return removed;
    }

    promptSelectors.forEach(function (selector) {
      root.querySelectorAll(selector).forEach(function (node) {
        if (!node || typeof node.remove !== 'function') {
          return;
        }

        node.remove();
        removed += 1;
      });
    });

    return removed;
  }

  function bindLauncherIntent(doc) {
    doc.addEventListener(
      'pointerdown',
      function (event) {
        if (event.target && typeof event.target.closest === 'function' && event.target.closest(launcherSelector)) {
          markLauncherInteraction();
        }
      },
      true
    );

    doc.addEventListener(
      'keydown',
      function (event) {
        if (
          (event.key === 'Enter' || event.key === ' ') &&
          event.target &&
          typeof event.target.closest === 'function' &&
          event.target.closest(launcherSelector)
        ) {
          markLauncherInteraction();
        }
      },
      true
    );
  }

  function start() {
    if (guardStarted) {
      return;
    }

    guardStarted = true;

    if (!window.location || !isMinionsPage(window.location.pathname) || !document.body) {
      return;
    }

    suppressAutoPrompt(document);
    bindLauncherIntent(document);

    if (typeof MutationObserver !== 'function') {
      return;
    }

    guardObserver = new MutationObserver(function () {
      if (!shouldSuppressPrompt()) {
        if (guardObserver) {
          guardObserver.disconnect();
          guardObserver = null;
          window.__minionsSmilePopupGuardObserver = null;
        }
        return;
      }

      suppressAutoPrompt(document);
    });

    guardObserver.observe(document.body, { childList: true, subtree: true });
    window.__minionsSmilePopupGuardObserver = guardObserver;
  }

  window.__minionsSmilePopupGuard = {
    isMinionsPage: isMinionsPage,
    markLauncherInteraction: markLauncherInteraction,
    shouldSuppressPrompt: shouldSuppressPrompt,
    suppressAutoPrompt: suppressAutoPrompt,
    start: start,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
